<div [formGroup]="formGroupRGPD" class="dialog-default">
    <h1 class="h1" mat-dialog-title><u>Conditions générales d'utilisation</u></h1>

    <p class="h5">Autorisations</p>
    <br>

    <p>• J’autorise la participation de mon enfant à toutes les activités et sorties proposées par Sport dans la
        Ville.</p>
    <p>• J’autorise le transport de mon enfant dans le cadre de ces activités et sorties.</p>
    <p>• J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure (traitement médical, hospitalisation)
        jugée nécessaire en cas d’incident survenu dans le cadre des activités de l’association.</p>
    <br>


    <mat-checkbox color="primary" formControlName="isInformationValid">
        Je soussigné(e), responsable de l’enfant, déclare exactes toutes les informations saisies & valide les
        autorisations
        précédemment citées.
    </mat-checkbox>
    <br>

    <mat-checkbox color="primary" formControlName="canTakePhotos">
        <p>Dans un objectif d’information et de communication, j’autorise Sport dans la Ville à utiliser des photos ou
            enregistrements de mon enfant, réalisés dans le cadre des activités de l’association. Ces éléments peuvent
            être
            publiés sur le site Internet de Sport dans la Ville, sur support papier, et télédiffusés. Certaines photos
            ou
            enregistrements pourront être utilisées par des partenaires financeurs de Sport dans la Ville pour un usage
            strictement non commercial, à des fins de communication sur les actions de Sport dans la Ville.</p>
        <p>S’agissant de l’autorisation du droit à l’image, les supports de diffusion sont bien décrits (si ce sont bien
            les
            seuls qui seront utilisés). En revanche, il manque des précisions sur le contexte de la prise d’images
            (évènements
            sportifs dans le cadre de l’association, rencontres publiques avec d’autres intervenants sportifs, etc.),
            sur la
            durée d’utilisation des images, sur la finalité de l’utilisation des images par Sport dans la Ville et sur
            la
            gratuité de cette utilisation par Sport dans la Ville. En effet, dans le projet d’autorisation envoyé, seule
            figure la finalité non commerciale pour les financeurs mais pas pour l’association Sport dans la Ville
            elle-même.
            Enfin, si cette autorisation devait couvrir la saison entière, elle mérite d’être plus détaillée.</p>
        <p>Je renonce à toute forme de rémunération ainsi qu’à tout recours ou poursuite de quelque nature que ce soit
            contre Sport dans la Ville.</p>
    </mat-checkbox>
    <br>

    <p class="h5">Clause RGPD</p>
    <br>

    <p>L’adhérent et le cas échéant, son représentant légal, est informé que l’Association SPORT DANS LA VILLE traite
        les
        données personnelles de ses membres dans la limite de ce qui est strictement nécessaire à l’exercice de son
        objet
        social.</p>
    <p>L’Association SPORT DANS LA VILLE est, au sens du Règlement UE 2016/679, responsable du traitement qu’elle opère
        des données personnelles qu’elle recueille dans les conditions décrites ci-dessous.</p>
    <p>Le traitement des données personnelles est réalisé afin d’enregistrer l’adhérent au sein de l’Association SPORT
        DANS LA VILLE et la bonne exécution des actions qu’elle s’engage à menées à l’égard de l’adhérent et plus
        généralement dans le cadre de l’exercice de son objet social.</p>
    <br>

    <p>L’Association SPORT DANS LA VILLE collecte, dans la limite de ce qui est strictement nécessaire à l’exécution
        dudit
        contrat, les données personnelles suivantes : NOM ET PRENOM DE L’ADHERENT, DATE DE NAISSANCE, NOM ET PRENOM DU
        REPRESENTANT LEGAL LE CAS ECHEANT, ADRESSE POSTALE, ADRESSE E-MAIL, TELEPHONE, SITUATION FAMILIALE, ETUDES,
        PROFESSION, SPORT PRATIQUE.</p>
    <p>A défaut de disposer de ces informations, l’Association SPORT DANS LA VILLE ne pourra pas mettre en œuvre les
        actions auxquelles l’Adhérent souhaite participer.</p>
    <p>Le traitement de ces données peut également être réalisé aux fins d’adresser à l’Adhérent les propositions
        d’activités, les informations sur l’actualité de l’Association SPORT DANS LA VILLE et ses actions, sous réserve
        que
        l’Adhérent y ait consenti lors de son adhésion en cochant la case à cet effet.</p>
    <p>Pour la majorité des données collectées, la durée de conservation est de 1 an à compter du terme de l’adhésion de
        l’Adhérent à l’Association SPORT DANS LA VILLE. Ces données pourront ensuite être archivées pendant une durée
        supplémentaire de 2 ans afin de préserver les droits de chacune des Parties.</p>
    <p>A la demande de certains de nos financeurs publics, comme le Fonds Social Européen, certaines données pourront
        être
        conservées 10 ans à compter du terme de l’adhésion de l’Adhérent à l’Association SPORT DANS LA VILLE ; ceci
        concerne
        principalement les adhérents qui souscrivent également au programme Job dans la Ville d’aide à l’insertion
        professionnelle. Ces données sont conservées dans un but de suivi et de rendus auprès de nos différents
        financeurs
        publics et privés.</p>
    <p>Seuls seront (ou pourront être) destinataires des données personnelles :</p>
    <p> - L’Association SPORT DANS LA VILLE</p>
    <p> - Son prestataire informatique en charge des opérations de traitement des données personnelles</p>
    <p> - Ses prestataires en charge de certaines activités ou autres actions et ses mécènes et financeurs publics
        s’intégrant dans le cadre de l’exercice de l’objet social de l’Association SPORT DANS LA VILLE</p>
    <br>

    <p>Les données personnelles traitées ne font pas l’objet d’un transfert hors Union-Européenne et sont stockées au
        sein
        de l’Union.</p>
    <p>Conformément à la règlementation relative à la protection des données personnelles (Règlement UE 2016/679 dit «
        RGPD), les personnes ont, sur les données personnelles les concernant :</p>
    <p> - Un droit d’accès aux données collectées</p>
    <p> - Un droit de rectification des données personnelles inexactes</p>
    <p> - Un droit à la limitation du traitement dans les conditions prévues à la section 3 du chapitre III du RGPD</p>
    <p> - Un droit à l’effacement dans les conditions prévues à la section 3 du chapitre III du RGPD</p>
    <p> - Un droit à la portabilité</p>
    <p> - Un droit d’opposition au traitement dans les conditions prévues à la section 4 du chapitre III du RGPD</p>
    <p> - Un droit de ne pas faire l’objet d’un traitement automatisé dans les conditions prévues à la section 4 du
        chapitre III du RGPD</p>
    <p> - Un droit de porter réclamation auprès de l’autorité nationale de contrôle, savoir la CNIL</p>
    <br>

    <p>Toute personne peut exercer ses droits en s’adressant, le cas échéant, à l’Association SPORT DANS LA VILLE aux
        coordonnées suivantes : Association SPORT DANS LA VILLE 15 quai de la Gare d’Eau, 69009 Lyon ou à l’adresse mail
        contact&#64;sportdanslaville.com</p>
    <br>

    <p class="h5">Conditions Générales d’activités</p>
    <br>

    <p><u>Article 1 : Bulletin d’inscription</u></p>
    <p>L’inscription aux activités proposées par Sport dans la Ville concerne tous les enfants des quartiers dans
        lesquels
        Sport dans la Ville dispose de terrains. Pour que l’inscription soit validée les enfants doivent avoir au moins
        6
        ans révolus. </p>
    <p>Il doit être établi lors de l’inscription ou du renouvellement. Il comporte tous les renseignements utiles
        concernant l’enfant. Il doit être visé par un médecin ou accompagné de la photocopie de la licence sportive de
        l’enfant et doit être signé par un responsable légal de l’enfant. Tout enfant n’ayant pas rendu tous les
        documents
        d’inscription et autorisations nécessaires ne pourra plus bénéficier des activités de Sport dans la Ville pour
        des
        raisons de sécurité et d’assurance ; qu’il s’agisse des séances sportives hebdomadaires ou toutes autres sorties
        et
        activités proposées par Sport dans la Ville. </p>
    <p>Au-delà de la fourniture du certificat médical et par mesure de sécurité, nous demandons à tous les jeunes de
        disposer d’une assurance responsabilité civile à jour ; cette assurance de responsabilité civile doit être
        détenue
        par le jeune lui-même ou par son représentant légal.</p>
    <br>

    <p>A noter que les séances sportives proposées par Sport dans la Ville sont encadrées par des éducateurs sportifs
        diplômés ; ceux-ci sont embauchés et suivis par Sport dans la Ville.</p>
    <p>Le fonctionnement et le programme pédagogique des séances est géré par les éducateurs responsables des différents
        sites. L’objectif étant d’avoir un planning pédagogique harmonisé sur l’ensemble du territoire national, la
        direction sportive accompagnera et supervisera les éducateurs.</p>
    <p>Sport dans la ville se réserve le droit de refuser l’inscription d’un adhérent pour des raisons de sécurité afin
        de
        garantir le bon déroulement des séances (par exemple en cas d’incivilité, de violence, d’un trop grand nombre de
        jeune pour mener la séance, …)</p>
    <br>

    <p><u>Article 2 : Respect des personnes et des biens</u></p>
    <p>Chaque enfant s’engage à respecter tous les autres jeunes de l’association, les éducateurs, le matériel, les
        moyens
        et équipements mis à leur disposition. Tout manquement de respect pourra être sanctionné par l’éducateur.
        Celui-ci
        pourra mettre en place une punition pédagogique sur le terrain ou, si besoin, exclure le jeune d’une séance ou
        d’une
        sortie.</p>
    <p>Les enfants doivent venir en tenue sportive (survêtement, short, t-shirt, basket ou crampons moulé/stabilisés,
        K-way en cas de pluie, gourde d’eau…).</p>
    <br>

    <p><u>Article 3 : Respect des horaires de séance et de rendez-vous</u></p>
    <p>Les animations sont proposées sur des créneaux horaires fixes, définis en début d’année, en fonction de l’âge des
        enfants. Chaque enfant s’engage à arriver à l’heure prévue pour sa séance et pour les sorties proposées par
        l’association. Tout manquement de respect des horaires pourra être sanctionné par l’éducateur. Celui-ci pourra
        mettre en place une punition pédagogique sur le terrain ou, en cas de répétition, exclure le jeune d’une séance
        ou
        d’une sortie.</p>
    <p>En dehors des créneaux horaires fixés pour chaque catégorie d’âge, les enfants ne sont plus sous la
        responsabilité
        de Sport dans la Ville, les éducateurs ne sont donc plus tenus de s’en occuper. Il incombe donc aux parents de
        venir
        chercher eux-mêmes leurs enfants dès la fin des séances ou des sorties s’ils le souhaitent. </p>
    <br>

    <p><u>Article 4 : Sensibilisation Sport et Nutrition</u></p>
    <p>Sport dans la Ville met en place durant la saison des actions sur cette thématique Sport & Nutrition. La taille
        et
        le poids de votre enfant vous sont demandés afin de pouvoir avoir des données sur l’ensemble du public accueilli
        sur
        nos terrains sportifs, et d’en suivre les évolutions dans les années à venir. Ces données seront traitées
        anonymement et analysée de manière globale par Sport dans la Ville afin d’appréhender l’impact et le bénéfice
        des
        programmes et activités. En revanche, ces données ne sont en aucun cas obligatoires pour l’inscription de votre
        enfant aux activités proposées par Sport dans la Ville.</p>

    <mat-checkbox color="primary" formControlName="isRGPDReaded">
        Je valide avoir pris connaissance des clauses RGPD et des Conditions Générales d’Activité et en approuve toutes
        les
        conditions.
    </mat-checkbox>
    <br>

    <mat-checkbox color="primary" formControlName="canContactResponsable">
        Je déclare accepter être contacté et recevoir des informations de la part de Sport dans la Ville dans l’objectif
        du
        bon déroulement des activités et différentes sorties.
    </mat-checkbox>
    <br>

    <div class="d-flex flex-row justify-content-end">
        <button (click)="Fermer()" class="btn btn-primary my-2 mx-2" type="button">Fermer</button>
    </div>
</div>
